// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"68d05a0a","127":"5eb94917","171":"8163e1a3","246":"01bc8468","342":"50125012","435":"d1bc500d","859":"5e5be732","925":"c1f55cbc"}[chunkId] + ".chunk.js";
};